module.exports = __webpack_public_path__ + "19427ea32faa80c42655b8df76936e78.pdf";